import { EntityRepository, Repository } from "typeorm";
import { DeheadingSample } from "../entities/deheading-sample.entity";

@EntityRepository(DeheadingSample)
export class DeheadingSampleRepository extends Repository<DeheadingSample> {

    
}